import { getMediaLargePlus } from '@utils/mediaQueries'
import { safeRound } from '@utils/safeRound'

import formatNumberToCurrency from './formatNumberToCurrency'

export function truncateToOneDecimalPlace(value: number) {
    if (value == null) {
        return 'N/A'
    }

    return safeRound(value, 1)
}

export const getFormattedMonth = (
    value?: number,
    format?: 'long' | 'short'
): string => {
    const resolvedFormat = format ?? (getMediaLargePlus() ? 'long' : 'short')

    if (value == null) {
        return 'N/A'
    }

    const monthText = resolvedFormat === 'short' ? 'mth' : 'month'

    return value === 1 ? `${value} ${monthText}` : `${value} ${monthText}s`
}

export const getFormattedAPR = (
    value?: number,
    useGuaranteedAPR?: boolean,
    guaranteedAPR?: number
): string => {
    if (value == null) {
        return 'N/A'
    }

    if (useGuaranteedAPR && guaranteedAPR) {
        return `${guaranteedAPR.toFixed(1)}%`
    }

    return `${value}%`
}

export const getFormattedCurrency = (amount?: number): string => {
    return formatNumberToCurrency(amount)
}

export const getFormattedInterestRate = (value: number): string => {
    if (Number.isInteger(value)) {
        return truncateToOneDecimalPlace(value)
    }
    return value?.toString()
}
